import React from 'react';
import { Building, Target, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';

const About = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Banner */}
      <section 
        className="relative h-[400px] flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(11, 44, 77, 0.85), rgba(11, 44, 77, 0.85)), url('https://images.unsplash.com/photo-1645301918921-6c744ab66e6f?w=1920')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold">About GoldenPort International Pvt. Ltd.</h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="prose prose-lg max-w-none">
            <div className="mb-12">
              <div className="flex items-center gap-4 mb-6">
                <Building className="w-12 h-12 text-[#C9A24D]" />
                <h2 className="text-3xl font-bold text-[#0B2C4D] m-0">Who We Are</h2>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                GoldenPort International Pvt. Ltd. is a DPIIT-recognised Indian startup working in export facilitation and trade finance coordination.
              </p>
            </div>

            <div className="mb-12">
              <div className="flex items-center gap-4 mb-6">
                <Target className="w-12 h-12 text-[#C9A24D]" />
                <h2 className="text-3xl font-bold text-[#0B2C4D] m-0">Our Mission</h2>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Our mission is to simplify exports for Indian manufacturers by removing buyer risk, payment delays, and documentation problems.
              </p>
            </div>

            <div className="mb-12">
              <div className="flex items-center gap-4 mb-6">
                <Users className="w-12 h-12 text-[#C9A24D]" />
                <h2 className="text-3xl font-bold text-[#0B2C4D] m-0">What Makes Us Different</h2>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                We act as a central export transaction manager, not a broker. This means we take responsibility for the entire export process, ensuring safety and reliability at every step.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg border-l-4 border-[#C9A24D] mb-8">
              <p className="text-xl text-[#0B2C4D] font-semibold mb-4">
                Why Choose GoldenPort?
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <span className="text-[#C9A24D] text-2xl">✓</span>
                  <span>DPIIT-recognised startup with government backing</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#C9A24D] text-2xl">✓</span>
                  <span>Specialized in India to Global exports (20+ countries)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#C9A24D] text-2xl">✓</span>
                  <span>Bank-controlled payment mechanisms</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#C9A24D] text-2xl">✓</span>
                  <span>End-to-end transaction management</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#C9A24D] text-2xl">✓</span>
                  <span>Focus on Indian MSMEs and manufacturers</span>
                </li>
              </ul>
            </div>

            <div className="text-center">
              <Button 
                size="lg"
                className="bg-[#C9A24D] hover:bg-[#b8923e] text-[#0B2C4D] font-semibold text-lg px-10 py-6"
                onClick={() => navigate('/contact')}
              >
                Enquiry Now
              </Button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
